module.exports = __webpack_public_path__ + "static/media/settings_icon.208c77c9.svg";